<template>
  <button type="button"
    class="tw-flex tw-items-center tw-gap-1 tw-bg-transparent tw-text-textOnDark tw-cursor-pointer hover:tw-bg-bgButtonHover hover:tw-text-white active:tw-bg-bgSideToggleActive/50 active:tw-text-white tw-transition tw-duration-300 tw-ease-in-out tw-py-2 tw-pl-3 tw-pr-2 tw-rounded-full"
    :title="$t('close')" :aria-label="$t('close')" @click="$emit('close')">
    <span>{{ $t("close") }}</span>
    <svg aria-hidden="true" class="tw-size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.4 19.2L4.8 17.6L10.4 12L4.8 6.4L6.4 4.8L12 10.4L17.6 4.8L19.2 6.4L13.6 12L19.2 17.6L17.6 19.2L12 13.6L6.4 19.2Z"
        fill="currentColor" />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'EditorCloseButton',
  emits: ['close'],
};
</script>
